module.exports = __webpack_public_path__ + "08_hair_brown.4756c551.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/08_hair_brown.png
// module id = +Er1
// module chunks = 0